import { createContext, useContext } from "react";
import { BaseCollapseContextValue } from "./types";

export const BaseCollapseContext = createContext<BaseCollapseContextValue | null>(null);

export const useBaseCollapseContext = () => {
    const context = useContext(BaseCollapseContext);
    if (!context) {
        throw new Error(
            "BaseCollapse.Header and BaseCollapse.Body must be used within BaseCollapse"
        );
    }
    return context;
};


